import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderEn = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Guess where the money is."
                highlights={[
                    { word: 'Guess' },
                    { word: 'where' },
                    { word: 'the' },
                    { word: 'money' },
                    { word: 'is.' },
                ]}
                breakAfterWords={isDesktop ? [] : ['where']}
                className={common.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>Three tries!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
